<template>
  <div>
    <agents :agents="agents"></agents>
  </div>
</template>
<script>
import Agents from '@/components/settings/Agents'
export default {
  components: {
    Agents
  },
  props: {
    agents: {
      type: Array,
      default () {
        return []
      }
    }
  }
}
</script>